import {
    CREATE_APPOINTMENT_STARTED,
    CREATE_APPOINTMENT_SUCCESS,
    CREATE_APPOINTMENT_FAILURE,
    GET_APPOINTMENTS_STARTED,
    GET_APPOINTMENTS_SUCCESS,
    GET_APPOINTMENTS_FAILURE,
    GET_APPOINTMENT_DETAIL_STARTED,
    GET_APPOINTMENT_DETAIL_SUCCESS,
    GET_APPOINTMENT_DETAIL_FAILURE,
    CREATE_BLOCK_TIME_STARTED,
    CREATE_BLOCK_TIME_SUCCESS,
    CREATE_BLOCK_TIME_FAILURE,
    UPDATE_BLOCK_TIME_STARTED,
    UPDATE_BLOCK_TIME_SUCCESS,
    UPDATE_BLOCK_TIME_FAILURE,
    REMOVE_BLOCK_TIME_STARTED,
    REMOVE_BLOCK_TIME_SUCCESS,
    REMOVE_BLOCK_TIME_FAILURE,
    UPDATE_APPOINTMENT_STARTED,
    UPDATE_APPOINTMENT_SUCCESS,
    UPDATE_APPOINTMENT_FAILURE,
    REMOVE_ERROR_MESSAGE
} from "../../constants/appointment/appointment";
import { LOGOUT } from "../../constants/authenticate/authenticate";

import API from "../../../utils/API";

export const updateAppointment = (appointment) => {
    return (dispatch) => {
        dispatch(updateAppointmentStarted());
        API.patch('/api/appointments/update-appointment', { appointment })
            .then((res) => {
                dispatch(updateAppointmentSuccess(res.data));
            })
            .catch((err) => {
                catchError(err, dispatch, updateAppointmentFailure);
            })
            .finally(() => {
                setTimeout(function () {
                    dispatch(removeErrorMessage());
                }, 1000);
            });
    };
};

const updateAppointmentStarted = () => ({
    type: UPDATE_APPOINTMENT_STARTED,
});

const updateAppointmentSuccess = (data) => ({
    type: UPDATE_APPOINTMENT_SUCCESS,
    payload: {
        data,
    },
});

const updateAppointmentFailure = (error) => ({
    type: UPDATE_APPOINTMENT_FAILURE,
    payload: { error },
});

export const createAppointment = (appointment) => {
    return (dispatch) => {
        dispatch(createAppointmentStarted());
        API.post('/api/appointments/create-appointment', { appointment })
            .then((res) => {
                dispatch(createAppointmentSuccess(res.data));
            })
            .catch((err) => {
                catchError(err, dispatch, createAppointmentFailure);
            })
            .finally(() => {
                setTimeout(function () {
                    dispatch(removeErrorMessage());
                }, 1000);
            });
    };
};

const createAppointmentStarted = () => ({
    type: CREATE_APPOINTMENT_STARTED,
});
const createAppointmentSuccess = (data) => ({
    type: CREATE_APPOINTMENT_SUCCESS,
    payload: {
        data,
    },
});
const createAppointmentFailure = (error) => ({
    type: CREATE_APPOINTMENT_FAILURE,
    payload: { error },
});

export const getAppointmentDetail = (aid) => {
    return (dispatch) => {
        dispatch(getAppointmentDetailStarted());
        return API.get(`/api/appointments/get-appointment-detail?appointmentId=${aid}`)
            .then((res) => {
                dispatch(getAppointmentDetailSuccess(res.data));
                return { success: true };
            })
            .catch((err) => {
                catchError(err, dispatch, getAppointmentDetailFailure);
                return { success: false, status: err.response?.status };
            })
            .finally(() => {
                setTimeout(() => {
                    dispatch(removeErrorMessage());
                }, 1000);
            });
    };
};
const getAppointmentDetailStarted = () => ({
    type: GET_APPOINTMENT_DETAIL_STARTED,
});

const getAppointmentDetailSuccess = (data) => ({
    type: GET_APPOINTMENT_DETAIL_SUCCESS,
    payload: {
        appointmentDetail: data
    },
});

const getAppointmentDetailFailure = (error) => ({
    type: GET_APPOINTMENT_DETAIL_FAILURE,
    payload: { error },
});

export const getAppointments = (date, timeZone) => {
    return (dispatch) => {
        dispatch(getAppointmentsStarted());
        API.get(`/api/appointments/get-appointments?date=${date}&timezone=${timeZone}`)
            .then((res) => {
                dispatch(getAppointmentsSuccess(res.data));
            })
            .catch((err) => {
                catchError(err, dispatch, getAppointmentsFailure)
            }).finally(() => {
                setTimeout(function () {
                    dispatch(removeErrorMessage());
                }, 1000);
            });
    };
}

const getAppointmentsStarted = () => ({
    type: GET_APPOINTMENTS_STARTED,
});

const getAppointmentsSuccess = (data) => ({
    type: GET_APPOINTMENTS_SUCCESS,
    payload: {
        appointments: data.appointments,
        staff: data.staff,
        staffHour: data.staffHour,
        holidayAndSpecialHour: data.holidayAndSpecialHour
    },
});

const getAppointmentsFailure = (error) => ({
    type: GET_APPOINTMENTS_FAILURE,
    payload: { error },
});

export const createBlockTime = (blockTime) => {
    return (dispatch) => {
        dispatch(createBlockTimeStarted());
        API.post('/api/appointments/create-block-time', blockTime)
            .then((res) => {
                dispatch(createBlockTimeSuccess(res.data));
            })
            .catch((err) => {
                catchError(err, dispatch, createBlockTimeFailure);
            })
            .finally(() => {
                setTimeout(function () {
                    dispatch(removeErrorMessage());
                }, 1000);
            });
    };
};

const createBlockTimeStarted = () => ({
    type: CREATE_BLOCK_TIME_STARTED,
});

const createBlockTimeSuccess = (data) => ({
    type: CREATE_BLOCK_TIME_SUCCESS,
    payload: {
        data,
    },
});

const createBlockTimeFailure = (error) => ({
    type: CREATE_BLOCK_TIME_FAILURE,
    payload: { error },
});



export const updateBlockTime = (blockTime) => {
    return (dispatch) => {
        dispatch(updateBlockTimeStarted());
        API.patch('/api/appointments/update-block-time', blockTime)
            .then((res) => {
                dispatch(updateBlockTimeSuccess(res.data));
            })
            .catch((err) => {
                catchError(err, dispatch, updateBlockTimeFailure);
            })
            .finally(() => {
                setTimeout(function () {
                    dispatch(removeErrorMessage());
                }, 1000);
            });
    };
};

const updateBlockTimeStarted = () => ({
    type: UPDATE_BLOCK_TIME_STARTED,
});

const updateBlockTimeSuccess = (data) => ({
    type: UPDATE_BLOCK_TIME_SUCCESS,
    payload: {
        data,
    },
});

const updateBlockTimeFailure = (error) => ({
    type: UPDATE_BLOCK_TIME_FAILURE,
    payload: { error },
});


export const removeBlockTime = (id) => {
    return (dispatch) => {
        dispatch(removeBlockTimeStarted());
        API.post('/api/appointments/delete-block-time', { id })
            .then((res) => {
                dispatch(removeBlockTimeSuccess(id));
            })
            .catch((err) => {
                catchError(err, dispatch, removeBlockTimeFailure);
            })
            .finally(() => {
                setTimeout(function () {
                    dispatch(removeErrorMessage());
                }, 1000);
            });
    };
};

const removeBlockTimeStarted = () => ({
    type: REMOVE_BLOCK_TIME_STARTED,
});

const removeBlockTimeSuccess = (id) => ({
    type: REMOVE_BLOCK_TIME_SUCCESS,
    payload: {
        data: id,
    },
});

const removeBlockTimeFailure = (error) => ({
    type: REMOVE_BLOCK_TIME_FAILURE,
    payload: { error },
});

const logoutUser = () => ({
    type: LOGOUT
})


const removeErrorMessage = () => ({
    type: REMOVE_ERROR_MESSAGE,
})


//Handle catch error
//logout use when unauthorized
//display error message and remove message after 3 seconds
const catchError = (error, dispatch, nextFunction) => {
    var message = error.message
    if (error.response) {
        message = error.response.data.message
        if (error.response.status === 401) {
            dispatch(logoutUser());
        }
    }

    dispatch(nextFunction(message));
};